export interface ITrustedPartnerApplication {
    companyName: string;
    companyRep: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    regions: string[];
    phone: string;
    email: string;
    numberOfEmployees: string;
    numberOfBranches: number;
    reasonForApplication: string;
    whyClientVitals: string;
    websiteLink: string;
    logo: FileList; 
    servicesNeeded: string[];
}

export const REGION_OPTIONS = [
    { id: 'NE', label: 'Northeast' },
    { id: 'SE', label: 'Southeast' },
    { id: 'Central', label: 'Central' },
    { id: 'NW', label: 'Northwest' },
    { id: 'SW', label: 'Southwest' }
];


export const EMPLOYEE_COUNT_OPTIONS = [
    { id: '0', label: 'No employees (Solopreneur)' },
    { id: '1-50', label: '2-10 employees (Small Business)' },
    { id: '51-500', label: '51-200 employees (Medium Business)' },
    { id: '501-1000', label: '501-1000 employees (Large Business)' },
    { id: '1000+', label: '1000+ employees (Enterprise)' }
];


export const SERVICE_OPTIONS = [
    { id: 'consultant', label: 'Consultant' },
    { id: 'soft-credit-pull', label: 'Soft Credit Pull' },
    { id: 'client-services', label: 'Client Services' },
    { id: 'education', label: 'Education' }
];


